(function () {
  const QUICK_BUY_FORM_MARKER = "product-form-quick-buy";

  const getQuickBuyPriceData = (root) => {
    const script = root && root.querySelector("[data-ps-quick-buy-variant-prices]");

    if (!script) {
      return null;
    }

    if (!script._petalsSmokeVariantPrices) {
      try {
        script._petalsSmokeVariantPrices = JSON.parse(script.textContent || "{}");
      } catch (error) {
        script._petalsSmokeVariantPrices = {};
      }
    }

    return script._petalsSmokeVariantPrices;
  };

  const replacePriceText = (element, value, srLabel) => {
    if (!element || !value) {
      return;
    }

    const screenReaderLabel = element.querySelector(".sr-only");
    element.textContent = "";

    if (screenReaderLabel) {
      screenReaderLabel.textContent = srLabel;
      element.appendChild(screenReaderLabel);
    }

    element.appendChild(document.createTextNode(value));
  };

  const syncQuickBuyPrice = (form, variantId) => {
    if (!form || !form.getAttribute("id")?.includes(QUICK_BUY_FORM_MARKER)) {
      return;
    }

    const root = form.closest(".quick-buy-modal__content") || form.closest("quick-buy-modal") || document;
    const variantPrices = getQuickBuyPriceData(root);
    const selectedPrice = variantPrices?.[String(variantId || form.querySelector('[name="id"]')?.value)];

    if (!selectedPrice) {
      return;
    }

    root.querySelectorAll("[data-ps-quick-buy-price]").forEach((priceList) => {
      const salePrice = priceList.querySelector("[data-ps-quick-buy-sale-price]");
      const compareAtPrice = priceList.querySelector("[data-ps-quick-buy-compare-at]");

      replacePriceText(
        salePrice,
        selectedPrice.price,
        selectedPrice.onSale ? "Sale price" : "Regular price"
      );

      if (salePrice) {
        salePrice.classList.toggle("text-on-sale", Boolean(selectedPrice.onSale));
        salePrice.classList.toggle("text-subdued", !selectedPrice.onSale);
      }

      if (compareAtPrice) {
        const shouldShowCompareAt = Boolean(selectedPrice.onSale && selectedPrice.compareAt);
        compareAtPrice.hidden = !shouldShowCompareAt;

        if (shouldShowCompareAt) {
          replacePriceText(compareAtPrice, selectedPrice.compareAt, "Regular price");
        }
      }
    });
  };

  document.addEventListener("change", (event) => {
    const input = event.target;

    if (!(input instanceof HTMLInputElement) || !input.matches(`input[data-option-position][form*="${QUICK_BUY_FORM_MARKER}"]`)) {
      return;
    }

    const form = document.getElementById(input.getAttribute("form"));
    const variantId = input.dataset.variantId;
    const variantIdInput = form?.querySelector('[name="id"]');

    if (!form || !variantId || !variantIdInput) {
      return;
    }

    variantIdInput.value = variantId;
    variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
    syncQuickBuyPrice(form, variantId);
  }, true);

  document.addEventListener("variant:change", (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : event.target?.closest?.("form");
    syncQuickBuyPrice(form, event.detail?.variant?.id);
  });
})();

